/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Requirement_DismissInputs */

const en_task_requirement_dismiss = /** @type {(inputs: Task_Requirement_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Document does not exist`)
};

const pt_br2_task_requirement_dismiss = /** @type {(inputs: Task_Requirement_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documento inexistente`)
};

/**
* | output |
* | --- |
* | "Document does not exist" |
*
* @param {Task_Requirement_DismissInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requirement_dismiss = /** @type {((inputs?: Task_Requirement_DismissInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requirement_DismissInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requirement_dismiss(inputs)
	return pt_br2_task_requirement_dismiss(inputs)
});